'use strict';

function alignRichTextListMarker() {
	document.querySelectorAll('ul li').forEach(li => {
		const style = getComputedStyle(li);
		if (style.getPropertyValue('--uses-marker').trim() === '1') {

			li.style.listStyle = 'none';
			
			const bullet = document.createElement('span');
			bullet.className = 'bullet';
			bullet.textContent = '•';

			li.prepend(bullet);

			const firstChild = Array.from(li.children).find(child => {
				if (!child.classList.contains('bullet')) {
					return getComputedStyle(child);
				}
			});

			if (firstChild) {
				const styles = getComputedStyle(firstChild);

				bullet.style.margin = styles.margin;
				bullet.style.fontSize = styles.fontSize;
				bullet.style.fontWeight = styles.fontWeight;
				bullet.style.lineHeight = styles.lineHeight;
				bullet.style.fontFamily = styles.fontFamily;
				bullet.style.color = styles.color;

			}

		}
	});
}

var init = function() {

    alignRichTextListMarker();

};

module.exports = {
	init: init
};